<template>
  <div class="study">
    <div class="degree-name">{{ value.nameText }}</div>
    <div class="degree-period" v-if="definedPeriod">{{ value.from }}-{{ value.till}} </div>
    <div class="university">{{ value.university }}</div>
    <div class="degree">{{ value.degree }}</div>
    <div class="grade">{{ value.grade }}</div>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: 'Study',

  data() {
    return {
      form: {},
      bufferedValue: null
    };
  },

  computed: {
    definedPeriod() {
      return this.value.from || this.value.till;
    }
  },

  props: {
    value: {
      type: Object,
      required: true
    },
    current: {
      type: Boolean,
      default: false
    }
  },

  filters: {
    moment(date) {
      return moment(date).format('MM/YY');
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../../scss/atoms/_colors';
@import '../../../scss/atoms/_typographie';
@import '../../../scss/atoms/_icons';

.study {
  padding-left: 33px;

  .degree-name {
    color: $color-blue;
    font-weight: $font-bold;
  }

  .degree-period {
    font-style: italic;
    font-weight: $font-regular;
    color: $color-disabled-grey;
  }
  /*
  .university {
    // padding-left: 33px;
  }
  */
}
</style>
